export const stepTimeFault = 1;//additional time that takes user to get data
export const stepTime = 10;//clear time to make step
export const stepTimeWithFault = stepTime + stepTimeFault;
